export default "__VITE_ASSET__Ch13bGVJ__"